import React from 'react';
import Icon from '../../../components/AppIcon';

console.log('Rendering SkillsVisualization');

const SkillsVisualization = () => {
  const skillCategories = [
    {
      id: 1,
      title: "Frontend Excellence",
      icon: "Layout",
      skills: [
        { name: "React/Next.js", proficiency: 95, color: "bg-primary" },
        { name: "TypeScript", proficiency: 90, color: "bg-primary" },
        { name: "Tailwind CSS", proficiency: 92, color: "bg-primary" },
        { name: "Vue.js/Angular", proficiency: 85, color: "bg-primary" }
      ]
    },
    {
      id: 2,
      title: "Backend Mastery",
      icon: "Server",
      skills: [
        { name: "Node.js/Express", proficiency: 93, color: "bg-success" },
        { name: "Python/Django", proficiency: 88, color: "bg-success" },
        { name: "PostgreSQL/MongoDB", proficiency: 90, color: "bg-success" },
        { name: "GraphQL/REST APIs", proficiency: 91, color: "bg-success" }
      ]
    },
    {
      id: 3,
      title: "DevOps & Cloud",
      icon: "Cloud",
      skills: [
        { name: "AWS/Azure", proficiency: 87, color: "bg-warning" },
        { name: "Docker/Kubernetes", proficiency: 85, color: "bg-warning" },
        { name: "CI/CD Pipelines", proficiency: 89, color: "bg-warning" },
        { name: "Monitoring & Logging", proficiency: 86, color: "bg-warning" }
      ]
    },
    {
      id: 4,
      title: "Architecture & Design",
      icon: "Boxes",
      skills: [
        { name: "System Design", proficiency: 92, color: "bg-accent" },
        { name: "Microservices", proficiency: 88, color: "bg-accent" },
        { name: "Performance Optimization", proficiency: 94, color: "bg-accent" },
        { name: "Security Best Practices", proficiency: 90, color: "bg-accent" }
      ]
    }
  ];

  return (
    <section className="py-16 md:py-20 lg:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-foreground mb-4">
            Technical Expertise
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            Full-stack capabilities with deep expertise across modern web technologies
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {skillCategories?.map((category) => (
            <div
              key={category?.id}
              className="bg-card rounded-xl p-6 md:p-8 border border-border hover:border-primary/50 transition-all duration-300"
            >
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary/10">
                  <Icon name={category?.icon} size={24} color="var(--color-primary)" />
                </div>
                <h3 className="text-xl md:text-2xl font-bold text-foreground">
                  {category?.title}
                </h3>
              </div>

              <div className="space-y-4">
                {category?.skills?.map((skill) => (
                  <div key={skill?.name}>
                    <div className="flex justify-between items-center mb-2">
                      <span className="text-sm md:text-base font-medium text-foreground">
                        {skill?.name}
                      </span>
                      <span className="text-sm font-bold text-primary">
                        {skill?.proficiency}%
                      </span>
                    </div>
                    <div className="h-2 bg-muted rounded-full overflow-hidden">
                      <div
                        className={`h-full ${skill?.color} rounded-full transition-all duration-1000 ease-out`}
                        style={{ width: `${skill?.proficiency}%` }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 md:mt-16 bg-card rounded-xl p-6 md:p-8 border border-border">
          <div className="text-center mb-8">
            <h3 className="text-xl md:text-2xl font-bold text-foreground mb-2">
              Additional Competencies
            </h3>
            <p className="text-sm md:text-base text-muted-foreground">
              Comprehensive skill set for end-to-end project delivery
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
            {[
              "WebSocket/Real-time",
              "Payment Integration",
              "OAuth/JWT Auth",
              "Redis Caching",
              "Elasticsearch",
              "WebRTC",
              "Testing (Jest/Cypress)",
              "Git/Version Control",
              "Agile/Scrum",
              "Technical Writing",
              "Code Review",
              "Mentoring"
            ]?.map((skill) => (
              <div
                key={skill}
                className="flex items-center gap-2 px-3 py-2 bg-background rounded-lg border border-border hover:border-primary/50 transition-colors duration-300"
              >
                <Icon name="CheckCircle2" size={16} color="var(--color-success)" />
                <span className="text-xs md:text-sm text-foreground">{skill}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SkillsVisualization;